export default function Security() {
  return (
    <section id="security" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
      
      <div className="absolute top-0 right-0 w-1/2 h-full bg-white transform skew-y-6 origin-top-right"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="text-white">
            <h2 className="text-5xl lg:text-6xl font-serif font-bold mb-8 leading-tight">
              Military-Grade Encryption
            </h2>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-blue-500 mt-2 flex-shrink-0"></div>
                <p className="text-lg text-gray-300 leading-relaxed">
                  AES-256 encryption standard used by governments and security experts worldwide to protect classified information
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-blue-500 mt-2 flex-shrink-0"></div>
                <p className="text-lg text-gray-300 leading-relaxed">
                  Perfect forward secrecy ensures that even if one session key is compromised, past and future sessions remain secure
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-blue-500 mt-2 flex-shrink-0"></div>
                <p className="text-lg text-gray-300 leading-relaxed">
                  DNS leak protection and automatic kill switch prevent your data from being exposed if the VPN connection drops
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Technical Specifications</h3>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Encryption</p>
                  <p className="text-sm font-mono text-gray-900">AES-256-GCM</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Protocol</p>
                  <p className="text-sm font-mono text-gray-900">OpenVPN / IKEv2</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Key Exchange</p>
                  <p className="text-sm font-mono text-gray-900">RSA-4096</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Hash Auth</p>
                  <p className="text-sm font-mono text-gray-900">SHA-512</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">DNS</p>
                  <p className="text-sm font-mono text-gray-900">Private DNS</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Kill Switch</p>
                  <p className="text-sm font-mono text-gray-900">Enabled</p>
                </div>
              </div>
              <div className="mt-8 pt-6 border-t border-gray-200">
                <a href="#contact" className="text-blue-600 text-sm font-medium hover:underline cursor-pointer inline-flex items-center gap-2">
                  Learn More About Our Security
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
